(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement"]) return;
  try {
    
  (() => {
    function updateCountdowns() {
      const now = new Date();
      const midnight = new Date(now);

      midnight.setHours(24, 0, 0, 0);

      const totalSeconds = Math.max(
        0,
        Math.floor((midnight.getTime() - now.getTime()) / 1000)
      );

      const hours = String(
        Math.floor(totalSeconds / 3600)
      ).padStart(2, '0');

      const minutes = String(
        Math.floor((totalSeconds % 3600) / 60)
      ).padStart(2, '0');

      const seconds = String(
        totalSeconds % 60
      ).padStart(2, '0');

      const value =
        hours + ' h ' +
        minutes + ' m ' +
        seconds + ' s';

      document.querySelectorAll(
        '.announcement-local-countdown'
      ).forEach((timer) => {
        if (timer.textContent !== value) {
          timer.textContent = value;
        }
      });
    }

    updateCountdowns();

    setInterval(updateCountdowns, 1000);

    document.addEventListener(
      'shopify:section:load',
      updateCountdowns
    );

    document.addEventListener(
      'visibilitychange',
      updateCountdowns
    );

    window.addEventListener(
      'pageshow',
      updateCountdowns
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
